import createBoundActionCreators, { createCustomCreator } from 'common/actionsBase';
import { selectCompletedIds } from '../selectors';

export const types = {
  SEND_SHOW_COMPLETED: 'SEND_SHOW_COMPLETED',
};

export default createBoundActionCreators(types, {
  SEND_SHOW_COMPLETED: createCustomCreator((uploader, dispatch, getState) => {
    const ids = selectCompletedIds(getState());
    uploader.sendShowCompleted(ids);
  }),
});
